/* MERRIN Roll-On — page behaviour (offer selector, gallery, FAQ, sticky bar, cart upsell) */
const money = (cents, fmt) => {
  const v = (cents / 100);
  const s = Number.isInteger(v) ? v.toFixed(0) : v.toFixed(2);
  return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, s);
};

/* ---------- offer selector ---------- */
function initOffer(root) {
  if (root.dataset.ready) return; root.dataset.ready = '1';
  const fmt = root.dataset.moneyFormat || '${{amount}}';
  const inputs = [...root.querySelectorAll('input[type=radio][name^="mr-pack"]')];
  const form = root.querySelector('product-form-component');
  const variantInput = form?.querySelector('input[name="id"]');
  const priceEls = root.querySelectorAll('[data-mr-price]');
  const shipEl = root.querySelector('[data-mr-ship]');
  const stickyName = document.querySelector('[data-mr-sticky-name]');
  const stickyMeta = document.querySelector('[data-mr-sticky-meta]');
  const stickyPrice = document.querySelector('[data-mr-sticky-price]');
  const apply = (input, broadcast = true) => {
    if (!input) return;
    if (variantInput) variantInput.value = input.value;
    priceEls.forEach(e => e.textContent = money(+input.dataset.price, fmt));
    if (shipEl) shipEl.innerHTML = input.dataset.shipHtml || '';
    if (root.dataset.primary === 'true') {
      if (stickyName) stickyName.textContent = input.dataset.label || '';
      if (stickyMeta) stickyMeta.textContent = input.dataset.shipText || '';
      if (stickyPrice) stickyPrice.textContent = money(+input.dataset.price, fmt);
    }
    if (broadcast) document.dispatchEvent(new CustomEvent('mr:pack', { detail: { variant: input.value } }));
  };
  inputs.forEach(i => i.addEventListener('change', () => apply(i)));
  document.addEventListener('mr:pack', e => {
    const m = inputs.find(i => i.value === e.detail.variant);
    if (m && !m.checked) { m.checked = true; apply(m, false); }
  });
  apply(inputs.find(i => i.checked) || inputs[0], false);
}

/* ---------- gallery: snap track, side arrows, thumb strip that follows the active slide ---------- */
function initGallery(g) {
  if (g.dataset.ready) return; g.dataset.ready = '1';
  const track = g.querySelector('.mr-gallery__track');
  const slides = [...g.querySelectorAll('.mr-gallery__slide')];
  const thumbs = [...g.querySelectorAll('.mr-gallery__thumbs button')];
  const strip = g.querySelector('.mr-gallery__thumbs');
  const prev = g.querySelector('[data-mr-prev]'), next = g.querySelector('[data-mr-next]');
  if (!track || slides.length === 0) return;
  let current = 0;
  const setCurrent = (i) => {
    current = Math.max(0, Math.min(slides.length - 1, i));
    g.style.setProperty('--gr', slides[current].dataset.ratio || '1');
    thumbs.forEach((t, k) => t.setAttribute('aria-current', k === current ? 'true' : 'false'));
    if (prev) prev.disabled = current === 0;
    if (next) next.disabled = current === slides.length - 1;
    const th = thumbs[current];
    if (th && strip) {
      const left = th.offsetLeft - (strip.clientWidth - th.offsetWidth) / 2;
      strip.scrollTo({ left, behavior: 'smooth' });
    }
    slides.forEach((s, k) => { const v = s.querySelector('video'); if (v && k !== current && !v.paused) v.pause(); });
  };
  const go = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setCurrent(i); };
  thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  prev?.addEventListener('click', () => go(current - 1));
  next?.addEventListener('click', () => go(current + 1));
  track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(current + 1); if (e.key === 'ArrowLeft') go(current - 1); });
  let raf;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== current) setCurrent(i); });
  }, { passive: true });
  setCurrent(0);
}

/* ---------- FAQ (smooth grid-rows animation) ---------- */
function initFaq(list) {
  if (list.dataset.ready) return; list.dataset.ready = '1';
  const single = list.dataset.single === 'true';
  list.querySelectorAll('.mr-faq__q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.mr-faq__item');
      const open = item.dataset.open === 'true';
      if (single) list.querySelectorAll('.mr-faq__item[data-open="true"]').forEach(o => { o.dataset.open = 'false'; o.querySelector('.mr-faq__q').setAttribute('aria-expanded', 'false'); });
      item.dataset.open = open ? 'false' : 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });
}

/* ---------- sticky mobile bar ---------- */
function initSticky(bar) {
  if (bar.dataset.ready) return; bar.dataset.ready = '1';
  const target = document.querySelector(bar.dataset.watch || '[data-mr-primary-atc]');
  const stop = document.querySelector(bar.dataset.stop || '');
  if (!target || !('IntersectionObserver' in window)) return;
  let atcVisible = true, stopVisible = false;
  const update = () => bar.dataset.visible = (!atcVisible && !stopVisible) ? 'true' : 'false';
  new IntersectionObserver(([e]) => { atcVisible = e.isIntersecting; update(); }, { threshold: 0 }).observe(target);
  if (stop) new IntersectionObserver(([e]) => { stopVisible = e.isIntersecting; update(); }, { threshold: 0.05 }).observe(stop);
  const pills = [...bar.querySelectorAll('[data-mr-sticky-pack]')];
  const setPills = (variant) => pills.forEach(p => p.setAttribute('aria-pressed', p.dataset.variant === String(variant) ? 'true' : 'false'));
  pills.forEach(p => p.addEventListener('click', () => {
    const input = document.querySelector('[data-mr-pdp] input[name^="mr-pack"][value="' + p.dataset.variant + '"]');
    if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  }));
  document.addEventListener('mr:pack', (e) => setPills(e.detail.variant));
  const checked = document.querySelector('[data-mr-pdp] input[name^="mr-pack"]:checked'); if (checked) setPills(checked.value);
  bar.querySelector('[data-mr-sticky-jump]')?.addEventListener('click', (ev) => {
    if (ev.currentTarget.getAttribute('form')) return; // real submit
    ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

/* ---------- scroll reveal ---------- */
function initReveal() {
  const els = document.querySelectorAll('.mr-reveal:not(.is-in)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
  const io = new IntersectionObserver((entries) => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
  els.forEach(e => io.observe(e));
}

/* ---------- cart drawer upsell (swap single -> duo, or add) ---------- */
async function cartUpgrade(btn) {
  const from = btn.dataset.fromVariant, to = btn.dataset.toVariant;
  if (!to) return;
  btn.disabled = true;
  const updates = {}; if (from) updates[from] = 0; updates[to] = 1;
  try {
    const res = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    const cart = await res.json();
    try {
      const { sectionRenderer } = await import('@theme/section-renderer');
      await sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration' });
    } catch (e) { console.warn('[mr] section re-render failed', e); }
    document.querySelectorAll('cart-icon').forEach(ci => ci.renderCartBubble?.(cart.item_count));
  } catch (e) { console.warn('[mr] cart update failed', e); btn.disabled = false; }
}
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-mr-cart-upgrade]');
  if (b) cartUpgrade(b);
});

/* ---------- cart reservation timer (per session, rolls over on expiry) ---------- */
(function timer() {
  const KEY = 'mr:reserve-deadline';
  const tick = () => {
    const els = document.querySelectorAll('[data-mr-timer]');
    if (!els.length) return;
    const mins = +els[0].dataset.mrTimer || 15;
    let deadline = +sessionStorage.getItem(KEY) || 0;
    if (!deadline || deadline - Date.now() <= 0) { deadline = Date.now() + mins * 60000; try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {} }
    const left = Math.max(0, Math.round((deadline - Date.now()) / 1000));
    const txt = `${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}`;
    els.forEach(el => { const c = el.querySelector('[data-mr-timer-clock]'); if (c && c.textContent !== txt) c.textContent = txt; });
  };
  setInterval(tick, 1000); tick();
})();

/* ---------- stat count-up ---------- */
function initCounts() {
  const els = document.querySelectorAll('[data-mr-count]:not([data-done])');
  if (!els.length) return;
  const run = (el) => {
    el.dataset.done = '1';
    const target = parseFloat(el.dataset.mrCount); if (isNaN(target)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = target; return; }
    if (document.hidden) { el.textContent = target; return; }
    const t0 = performance.now(), dur = 1100;
    const tick = (now) => { const p = Math.min(1, (now - t0) / dur); const e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(target * e); if (p < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  };
  if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
  const io = new IntersectionObserver((en) => en.forEach(x => { if (x.isIntersecting) { run(x.target); io.unobserve(x.target); } }), { threshold: 0.4 });
  els.forEach(e => io.observe(e));
}

/* ---------- boot ---------- */
function boot(scope = document) {
  scope.querySelectorAll('[data-mr-offer]').forEach(initOffer);
  scope.querySelectorAll('[data-mr-gallery]').forEach(initGallery);
  scope.querySelectorAll('[data-mr-faq]').forEach(initFaq);
  scope.querySelectorAll('[data-mr-sticky]').forEach(initSticky);
  initReveal();
  initCounts();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
document.addEventListener('shopify:section:load', (e) => boot(e.target));
